var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationalIDIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2821_2011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.625C1.5 4.92881 1.81607 4.26113 2.37868 3.76884C2.94129 3.27656 3.70435 3 4.5 3H16.5C17.2956 3 18.0587 3.27656 18.6213 3.76884C19.1839 4.26113 19.5 4.92881 19.5 5.625V14.375C19.5 15.0712 19.1839 15.7389 18.6213 16.2312C18.0587 16.7234 17.2956 17 16.5 17H4.5C3.70435 17 2.94129 16.7234 2.37868 16.2312C1.81607 15.7389 1.5 15.0712 1.5 14.375V5.625Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33366C5 8.77569 5.17559 9.19961 5.48816 9.51217C5.80072 9.82473 6.22464 10.0003 6.66667 10.0003C7.10869 10.0003 7.53262 9.82473 7.84518 9.51217C8.15774 9.19961 8.33333 8.77569 8.33333 8.33366C8.33333 7.89163 8.15774 7.46771 7.84518 7.15515C7.53262 6.84259 7.10869 6.66699 6.66667 6.66699C6.22464 6.66699 5.80072 6.84259 5.48816 7.15515C5.17559 7.46771 5 7.89163 5 8.33366Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7H16.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10H16.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13H16.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2821_2011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalIDIcon);
export default __webpack_public_path__ + "static/media/National-iD-icon.512d0603574a3668cab308fd61d6cd18.svg";
export { ForwardRef as ReactComponent };